// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20XQu","col":"styles_col__1bUjv"};